import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "entry", "destroyField"]

  add() {
    const template = this.templateTarget.innerHTML
    const index = new Date().getTime()
    const html = template.replace(/NEW_INDEX/g, index)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    const entry = event.target.closest("[data-service-addons-target='entry']")
    const destroyField = entry.querySelector("[data-service-addons-target='destroyField']")

    if (destroyField && entry.dataset.persisted) {
      // Persisted record - mark for destruction and hide
      destroyField.value = "true"
      entry.classList.add("hidden")
    } else {
      // New record - just remove from DOM
      entry.remove()
    }
  }
}
